import axios from 'axios'
import { cleanMetaText } from '~/utils/htmlEntities'

const showImage = (i) => {
  if (i) {

    let imaj = i
    imaj = imaj.replace('http://inancturizm.gen.tr/', 'https://yonetim.inanctur.com.tr/');
    imaj = imaj.replace("http://", "https://")
    imaj = imaj.replace("inanctur.kolaysite.co/", "image.inanctur.com.tr/")
    imaj = imaj.replace("//inanctur.com.tr/", "//image.inanctur.com.tr/")
    if (imaj.charAt(0) == "/") {
      return "https://image.inanctur.com.tr" + imaj
    } else if (i.charAt(0) == "v") {
      return "https://image.inanctur.com.tr" + imaj
    }

    return imaj;
  }
} 

const  decodeHTMLEntities = (text,data)=>{
  var entities = {
    'amp': '&',
    'apos': '\'',
    'lt': '<',
    'gt': '>',
    'quot': '"',
    'nbsp': '\xa0',
    '&Ouml;': 'Ö',
    '&cc': 'g',
  };
  var entityPattern = /&([a-z]+);/ig;
   
    if(text && typeof text == "string"){
        // A single replace pass with a static RegExp is faster than a loop
        return text.replace(entityPattern, function(match, entity) {
          entity = entity.toLowerCase();
          if (entities.hasOwnProperty(entity)) {
            return entities[entity];
          }
          // return original string if there is no matching entity (no replace)
          return match;
        });
    }
  return text;
}
  


// composables/useVideoSchema.ts
const  useVideoSchema = (htmlContent,pageData)=>{ 
 
  let htmlContento = decodeHTMLEntities(htmlContent, pageData)

  const videos  = []

// YouTube iframe'leri bul
const iframeRegex = /<iframe\b[^>]*?\s+src=["']([^"']+)["'][^>]*?(?:title=["']([^"']+)["'])?[^>]*?>.*?<\/iframe>/gi
let match
while ((match = iframeRegex.exec(htmlContento)) !== null) {
  const src = match[1]
  const title = match[2] || 'Embedded Video'
  const today = new Date().toISOString()

  let thumbnailUrl = 'https://img.youtube.com/vi/e1qOAkVum18/hqdefault.jpg';
    // YouTube için özel thumbnail
    const youtubeMatch = src.match(/youtube\.com\/embed\/([^?&"'>]+)/)
    if (youtubeMatch) {
      const videoId = youtubeMatch[1]
      thumbnailUrl = `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`
    }



  if (src.includes('youtube.com') || src.includes('vimeo.com')) {
    videos.push({
      "@context": "https://schema.org",
      "@type": "VideoObject",
      "name": pageData.SA_Baslik+ " video" || title,
      "description": pageData.SA_Baslik+ " video" ||  title,
      "embedUrl": src,
      "thumbnailUrl": thumbnailUrl,
      "uploadDate": pageData.updated_on || today,
    })
  }
}

// <video> etiketlerini bul
const videoRegex = /<video[^>]*src=["']([^"']+)["'][^>]*title=["']?([^"']*)["']?[^>]*>.*?<\/video>/gi
while ((match = videoRegex.exec(htmlContento)) !== null) {
  const src = match[1]
  const title = match[2] || 'Video'

  videos.push({
    "@context": "https://schema.org",
    "@type": "VideoObject",
    "name": title,
    "description": title,
    "contentUrl": src,
    "thumbnailUrl": thumbnailUrl,
    "uploadDate": pageData.updated_on,
  })
} 
return videos
}



const isJsonString = (str) => {
  if (str) {
      try {
          JSON.parse(str);
      } catch (e) {
          return false;
      }
      return true;
  } else {
      return false
  }
}; 

const adminBaseLabels = {
  accounting: 'Muhasebe',
  reservations: 'Rezervasyonlar',
  customers: 'Cariler',
  reports: 'Raporlar',
  dashboard: 'Dashboard',
  tour: 'Tur',
  operation: 'Operasyon',
  hotel: 'Oteller',
  availability: 'Musaitlik',
  notes: 'Notlar',
  passports: 'Pasaportlar',
  tasks: 'Gorevler',
  comments: 'Yorumlar',
  offer: 'Teklifler',
  calls: 'Aramalar',
  phones: 'Telefonlar',
  count: 'Sayim',
  user: 'Kullanici',
  manage: 'Yonetim',
  microapi: 'Micro API',
  'private-tours': 'Ozel Turlar',
  'pax-files': 'Pax Dosyalari',
  messages: 'Mesajlar',
  'userDataForm': 'Kullanici Formu',
  'persona-status': 'Persona Durumu'
}

const toTitleCase = (value) => {
  return String(value || '')
    .split(' ')
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ')
}

const formatAdminSegment = (segment) => {
  const value = String(segment || '').trim()
  if (!value) return ''
  if (/^\d+$/.test(value)) return ''
  if (/^\d{4}-\d{2}-\d{2}$/.test(value)) return ''

  const short = value
    .replace(/\.[a-z0-9]+$/i, '')
    .split('-')[0]
    .replace(/_/g, ' ')

  if (!short) return ''
  return toTitleCase(short.replace(/-/g, ' '))
}

const getAdminMetaTitle = (to) => {
  const cleanPath = String(to?.path || '').replace(/^\/|\/$/g, '')
  const parts = cleanPath.split('/').filter(Boolean)
  if (parts[0] !== 'admin') return ''

  const baseKey = parts[1] || 'dashboard'
  const baseLabel = adminBaseLabels[baseKey] || toTitleCase(String(baseKey).replace(/-/g, ' '))
  const detailLabel = formatAdminSegment(parts[2])

  if (detailLabel) return `${baseLabel} ${detailLabel}`
  return baseLabel || 'Admin'
}
 

export default defineNuxtRouteMiddleware(async (to, from) => {

    const currentYear = String(new Date().getFullYear())
    const nextYear = String(new Date().getFullYear() + 1)
    const curatedUmrahLandingPaths = new Set([
      '/tour/umre-turlari',
      '/tour/5-yildizli-luks-umre-turlari',
      '/tour/vip-umre-programlari',
      '/page/delux-umre-konsepti',
      '/en/tour/umrah-tours',
      '/en/tour/5-star-luxury-umrah-packages',
      '/en/tour/vip-luxury-umrah-packages'
    ])

    if (to?.path?.startsWith('/admin')) {
      const adminTitle = getAdminMetaTitle(to)
      useHead({
        title: `${adminTitle} | Inanc Tur Admin`
      })
      return
    }

  
 
    const pageData = usePageData(); 
    const url = to.path;
    const { slug, locale, isPage, isTourDetail } = useSlug(url);
 
    const config = useRuntimeConfig();
    let data = {};
 
   
      // Relative $fetch, Nuxt'un SSR iç isteğini kullanır. baseURL'yi '/' diye
      // zorlamak SSR'de isteğin boş dönmesine ve dinamik sayfaların 404 olmasına
      // neden olabiliyordu.
      data = await $fetch('/api/page/find', { params: { locale, slug, isPage } })
    
  
      if (data?.unavailable) {
        pageData.value = { unavailable: true };
        return;
      }
      if (data?.notFound || !data || !data.from_KurumsalSayfalar) {
        pageData.value = { notFound: true };
        return;
      }
      let tourIds =  ["TourCategory","TourDates"]; 
      let wa_MainGroup = data?.wa_MainGroup; 
      if(wa_MainGroup && to.fullPath.startsWith("/page/") && tourIds.includes(wa_MainGroup)){ 
          let url1 = to?.params?.link;  
          console.log("url1",url1)
          return false;
      }

      data.SA_Fotograf = data.from_KurumsalSayfalar.SA_Fotograf;
      data.SA_Baslik = data.from_KurumsalSayfalar.SA_Baslik;
      data.SA_Sound = data.from_KurumsalSayfalar.SA_Sound;
      data.SA_PageTopImage = data.from_KurumsalSayfalar.SA_PageTopImage;
      data.SA_Subtitle = data.from_KurumsalSayfalar.SA_Subtitle;
      data.SA_Link = data.from_KurumsalSayfalar.SA_Link;
      const pageUrls = data.from_KurumsalSayfalar.SA_Urls;
      if (typeof pageUrls === 'string' && pageUrls.charAt(0) === "{" && isJsonString(pageUrls)) {
        data.SA_Urls = JSON.parse(pageUrls);
      } else if (pageUrls && typeof pageUrls === 'object') {
        data.SA_Urls = pageUrls;
      }

      data.SA_UstSayfa = data.from_KurumsalSayfalar.SA_UstSayfa;
      data.SA_Yazilar = data.from_KurumsalSayfalar.SA_Yazilar;
      data.pdb_categories = data.from_KurumsalSayfalar.pdb_categories;
      data.updated_on = data.created_on;
      data.created_on = data.from_KurumsalSayfalar.created_on; 

      // This evergreen guide is maintained in the page component so the
      // rendered article and structured data always describe the same copy.
      // Do not leave an older CMS body or FAQ hidden in the Nuxt payload.
      if (to.path === '/page/delux-umre-konsepti') {
        data.SA_Yazilar = null
        data.SA_Jsonld = null
        data.faq = null
      }

      data.wa_title = data.wa_title.replaceAll("[title]",data.wa_pagetitle);
      data.wa_description = data.wa_description.replaceAll("[title]",data.wa_pagetitle);
      data.wa_keywords = data.wa_keywords.replaceAll("[title]",data.wa_pagetitle);

      data.wa_title = data.wa_title.replaceAll("[firm]","İnanç Turizm");
      data.wa_description = data.wa_description.replaceAll("[firm]","İnanç Turizm");
      data.wa_keywords = data.wa_keywords.replaceAll("[firm]","İnanç Turizm");

      data.wa_title = data.wa_title.replaceAll("[year]", currentYear);
      data.wa_description = data.wa_description.replaceAll("[year]", currentYear);
      data.wa_keywords = data.wa_keywords.replaceAll("[year]", currentYear);

    
      if(data && typeof data?.from_KurumsalSayfalar?.SA_Jsonld === 'string' && data.from_KurumsalSayfalar.SA_Jsonld.charAt(0) == "{" && isJsonString(data.from_KurumsalSayfalar.SA_Jsonld)){

        let jsonld = JSON.parse(data?.from_KurumsalSayfalar?.SA_Jsonld);
        if (jsonld && jsonld["@context"] && jsonld["@context"] == "https://schema.org") {
          data.SA_Jsonld = jsonld;
        } else {
          data.SA_Jsonld = null;
        }   

        // These commercial landing pages provide maintained, visible FAQ
        // content in the page itself. Avoid publishing the older CMS FAQ in
        // parallel, which could leave stale prices and duplicate schema.
        if (curatedUmrahLandingPaths.has(to.path)) {
          // Do not serialize stale CMS FAQ copy into the Nuxt payload either;
          // crawlers and AI retrieval systems can inspect embedded JSON.
          data.SA_Jsonld = null
        } else {
          data.faq = jsonld["mainEntity"]
          useHead({
            script: [
              {
                type: 'application/ld+json',
                children: JSON.stringify(data.SA_Jsonld)
              }
            ]
          })
        }

      } 


      delete data.from_KurumsalSayfalar;

      if (data && data.SA_Fotograf) {
        data.SA_Fotograf = data?.SA_Fotograf ? showImage(data.SA_Fotograf) : '';
      }
      
     

      pageData.value = data; 
  
 
  if (data || (to?.meta?.title && to?.meta?.description)) {

    // Canonical URLs must never inherit tracking, comparison or filter query
    // parameters. Keep one clean URL for every document.
    let fullPath = to?.path?.slice(-1) == "/" && to?.path !== "/" ? to?.path.slice(0, -1) : to?.path;
    if (to.path == "" || to.path == "/" || to.path.startsWith("/tr")) {
      fullPath = fullPath.replace("/tr/", "/")
    }

    let script = null
    if (isTourDetail) {

      let name = data?.SA_Baslik;
      let startDate = name.split(" ")?.[0]?.split("-");
      let endDate = name.split(" ")?.[1]?.split("-");
      if (startDate[2]) {
        startDate = startDate[2] + "-" + startDate[1] + "-" + startDate[0]
      }
      if (endDate[2]) {
        endDate = endDate[2] + "-" + endDate[1] + "-" + endDate[0]
      }
      if (locale == "tr") {
        name = 'Umre Turu - ' + data?.SA_Baslik + " gün";
      } else {
        name = 'Umrah Tour - ' + data?.SA_Baslik + " days";
      }
      let categories = {}
      let hotelName = '';
      let location = '';

      if (data.pdb_categories && data.pdb_categories.charAt(0) == "{") {
          categories = JSON.parse(data.pdb_categories)

          let subcat = categories?.SubCat;
          if (subcat && subcat.includes("MOVENPICKUMRE")) {
            hotelName = ' Makkah Towers Hotel';
            location = {
              "@type": "Place",
              "name": hotelName,
              "address": {
                "@type": "PostalAddress",
                "streetAddress": "شارع إبراهيم الخليل, Al Haram, Makkah",
                "postalCode": "21955",
                "addressCountry": "SA"
              }
            }
          } else if (subcat && subcat.includes("ANJUMUMRE")) {
            hotelName = 'Anjum Hotel Makkah';
            location = {
              "@type": "Place",
              "name": hotelName,
              "address": {
                "@type": "PostalAddress",
                "streetAddress": "Umm Al Qura Street, Haratal Bab And Ash Shamiyyah, Makkah",
                "postalCode": "21955",
                "addressCountry": "SA"
              }
            }
          } 
          name = name + " " + hotelName

      }
      script = [
        {
          type: 'application/ld+json',
          children: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Event",
            "name": name,
            "startDate": startDate + "T12:00+03:00",
            "endDate": endDate + "T19:00+03:00",
            "eventAttendanceMode": "https://schema.org/OfflineEventAttendanceMode",
            "eventStatus": "https://schema.org/EventScheduled",
            "image": [
              data?.SA_Fotograf || "https://inanctur.com.tr/assets/img/logo/logo.png"
            ],
            "location": location,
            "offers": {
              "@type": "Offer",
              "url": "https://inanctur.com.tr" + fullPath,
            },
            "organizer": [{
              "@type": "Organization",
              "name": "Inanc Turizm"
            }]
          })
        }
      ]

    } else if (isPage) {
      script = []
    }


    if(data.SA_Yazilar){ 
        let videos = useVideoSchema(data.SA_Yazilar,data); 
        if(videos.length > 0){
          script.push({
            type: 'application/ld+json',
            children: JSON.stringify(videos)
          })
        }
      }

    let title = cleanMetaText(data?.wa_title?.replace("[firm]", "Inanc Tour").replace("[title]", "Inanc Turizm").replace("[year]", currentYear).replace("[yearn]", nextYear))
    let desc = cleanMetaText(data?.wa_description?.replace("[firm]", "Inanc Tour").replace("[title]", "Inanc Turizm Umre").replace("[year]", currentYear).replace("[yearn]", nextYear))
    let keywords = cleanMetaText(data?.wa_keywords)

    if (fullPath.includes("#")) {
      fullPath = fullPath.split("#")?.[0] || fullPath;
    }
    useHead({
      title: title || to?.meta?.title,
      description: desc || data?.excerpt || to?.meta?.description,
      fullPath,
      link: [
        {
          rel: 'canonical',
          href: "https://inanctur.com.tr" + fullPath,
        },
      ],
      script
    });


    if (data.wa_title) {
      useSeoMeta({
        title: title || "Inanctur.com.tr",
        ogTitle: title || "Inanctur.com.tr",
        description: desc || "Inanctur.com.tr",
        keywords: keywords || undefined,
        ogDescription: desc || "Inanctur.com.tr",
        ogUrl: "https://inanctur.com.tr" + fullPath,
        ogSiteName: "İnanç Turizm",
        ogType: "website",
        ogImage: data.SA_Fotograf || "https://inanctur.com.tr/assets/img/logo/logo.png"
      })
    }

  } else {

    
    if (typeof url == "string" && (url.includes("error")  || url.startsWith("error") || url.startsWith("tourDetail") || url.startsWith("en/tourDetail"))) {



    } else {
      //window.location.href = "/error"
    } 

  }

});
